import { b as u } from "../../create-theme-C4Hb_-Ag.js";
function o(n, e, l) {
  const { mediaQuery: s } = u;
  let i;
  Array.isArray(e) ? i = e : i = [e];
  const r = [
    null,
    s.small,
    s.medium,
    s.large
  ];
  return i.slice(0, r.length).map((a, t) => ({
    [n]: l ? l(a) : a,
    mediaquery: r[t]
  }));
}
export {
  o as useResponsiveStyle
};
